import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import LectureLessonHistoriesApi from '../generated/api/LectureLessonHistories';

export default (service: Servicelayer) => ({
  ...LectureLessonHistoriesApi(service),

  // Add custom calls here

});
